import { createReducer, on } from '@ngrx/store';
import { ODataResponse, ODataParams, odataParamsFactory } from '@tdw/core';
import { ClosureAdminFilter, ClosureProduct, ClosureProductAssociatedProduct, closureProductFactory, closuresAdminFilterFactory } from 'src/app/models';
import * as fromStore from '../../../store';
import { Loaders } from '.';


export interface State {
  closures?: ODataResponse<ClosureProduct[]>;
  closuresQuery: ODataParams;
  closureAdminFilter: ClosureAdminFilter;
  currentlyEditing: { closureProduct: ClosureProduct | null, associatedProducts?: ClosureProductAssociatedProduct[] };
  loaders: Loaders[];
}

export const initialState: State = {
  currentlyEditing: { closureProduct: null, associatedProducts: [] },
  closuresQuery: odataParamsFactory({
    top: 50,
    expand: 'Diameter($select=id,text,description,inactiveDate,createddate,createdby,updateddate,updatedby),HingeOrientation($select=id,text,description,inactiveDate,createddate,createdby,updateddate,updatedby),WallThickness($select=id,text,description,inactiveDate,createddate,createdby,updateddate,updatedby),ClampRing($select=id,text,description,inactiveDate,createddate,createdby,updateddate,updatedby)',
    orderBy: 'id desc',
    select: ['id', 'partNumber', 'productName', 'description', 'diameterId', 'flanged', 'wallThicknessId', 'pressureRatingId', 'maxDesignPressure', 'minDesignTemp', 'maxDesignTemp', 'hingeOrientationId', 'clampRingId', 'designFactorId', 'weight', 'restricted', 'restrictedNotice', 'inactiveDate', 'notes', 'createdDate', 'createdBy', 'updatedDate', 'updatedBy'],
    skip: 0,
    count: true
  }),
  closureAdminFilter: closuresAdminFilterFactory({}),
  loaders: []
};

export const reducer = createReducer(
  initialState,
  on(fromStore.actions.ADMIN.loadClosures, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingClosures),
  })),
  on(fromStore.actions.ADMIN.loadClosuresSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingClosures),
    closures: action.closures
  })),
  on(fromStore.actions.ADMIN.loadClosuresFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingClosures)
  })),
  on(fromStore.actions.ADMIN.loadClosuresForPage, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingClosures),
    closuresQuery: {
      ...state.closuresQuery,
      skip: (state.closuresQuery.top * (action.page - 1))
    },
  })),
  on(fromStore.actions.ADMIN.updateClosuresAdminFilter, (state: State, action) => ({
    ...state,
    closureAdminFilter: Object.assign({}, state.closureAdminFilter, action.obj)
  })),

  on(fromStore.actions.ADMIN.loadCurrentlyEditingClosure, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingMaintainenceEditorFitting),
    currentlyEditing: {
      ...state.currentlyEditing,
      closureProduct: !!action.closureId ? state.currentlyEditing.closureProduct : closureProductFactory({}),
      // associatedProducts: !!action.closureId ? state.currentlyEditing.associatedProducts : []
    }
  })),
  on(fromStore.actions.ADMIN.loadCurrentlyEditingClosureSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingMaintainenceEditorFitting),
    currentlyEditing: {
      ...state.currentlyEditing,
      closureProduct: action.closure
    }
  })),

);
